export const stepOneData = [
  {
    heading: "Key Features of Gold Loan EMI Calculator",

    infoList: [
      {
        heading: " Instant Calculations:  ",
        description:
          "Get EMI results instantly by entering basic loan details.",
      },
      {
        heading: "Customizable Inputs:",
        description:
          "Adjust loan amount, tenure, and interest rates for personalized results.",
      },
      {
        heading: "Accurate Results: ",
        description: "Calculate EMIs with precision to plan your repayments.",
      },
      {
        heading: " Compare Offers:   ",
        description:
          "Evaluate different lender options for better decision-making.",
      },
      {
        heading: "User-Friendly Interface:   ",
        description: "Simple and intuitive tool designed for everyone.",
      },
    ],
    headingTwo: "How to Use the Gold Loan EMI Calculator",

    infoListTwo: [
      {
        heading: "Enter Loan Amount: ",
        description: "Input the loan amount you wish to borrow.",
      },
      {
        heading: " Provide Interest Rate:  ",
        description:
          "Fill in the applicable interest rate offered by the lender.",
      },
      {
        heading: "Select Loan Tenure: ",
        description: "Choose the loan tenure (in months or years).",
      },
      {
        heading: "Click on ‘Calculate EMI’:  ",
        description:
          "Instantly get your monthly EMI along with a detailed breakdown.",
      },
    ],

    headingThree: "What Types of Gold Are Eligible as Collateral?",
    headThreeInfo:
      "Most lenders accept gold items as collateral, but they must meet certain basic criteria. Typically, the gold should have a purity level of at least 18 karats. Additionally, many reputed lenders only accept gold jewelry as collateral, excluding items like gold coins or bars from eligibility.",
    minEmiTipHead: "Choose the Right Time for Balance Transfer",
    minemiTip:
      "Before applying for a gold loan, check the specific eligibility requirements of your lender to ensure your gold assets qualify. This saves time and helps streamline the application process.",

    headingfour: "Three Flexible Repayment Methods for Gold Loans",
    headfourInfo:
      "Gold loan borrowers can opt for one of these flexible repayment options in addition to the traditional EMI method:",

    infoListfour: [
      {
        heading: "Interest Payment Only: ",
        description:
          "In this option, borrowers pay only the interest amount monthly while deferring the principal repayment to the end of the loan tenure. This method offers immediate affordability but requires a lump-sum principal payment at the end.",
      },
      {
        heading: " Bullet Repayment:  ",
        description:
          "With bullet repayment, both the principal and interest are paid in a single lump sum at the end of the loan tenure. This is ideal for borrowers who prefer to avoid monthly obligations and settle the dues at the end, such as after a year for a 12-month tenure.",
      },
      {
        heading: "Part Payment:",
        description:
          "Borrowers choosing this option can make regular EMI payments and prepay additional amounts toward the principal whenever feasible. Prepaying reduces the principal outstanding, which in turn lowers the overall interest cost.",
      },
    ],
  },
];

export const disclaimerData = [
  {
    id: 1,
    disclaimer: "Disclaimer",

    information: [
      {
        id: 1,

        infotext:
          "This intractive tool is provided by MinEmi.ai for informational purposes only and does not constitute an offer or solicitation for the purches or sale of any financial product or service. MinEmi.ai and its affiliates shall not be held responsible for any errors,omissions, or consequences arising from the use of the information provided.",
      },
      {
        id: 2,

        infotext:
          "Users are advised to independently verify the accuracy of the data and seek professional advice before making any financial decisions. The result genrated by this tool are indictive and should not be the sole basis for invesment or loan-related decisions",
      },
      {
        id: 3,

        infotext:
          "This information is subject to change without notic, and MinEmi.ai reserves the right to modify or update it at anr time. MinEmi.ai and its affiliates, directors ,employees, and representatives disclaim all liability for any losses or damages arising from the user or reliance on this informaton. Past performance or projections do not giarantee future outcomes.",
      },
    ],
  },
];

export const stepTwoData = [
  {
    minemiTip:
      "Choose a repayment option based on your financial planning and cash flow. Ensure you confirm your choice at the time of loan application, as repayment methods cannot typically be changed mid-tenure.",

    heading: "Benefits of Planning with a Gold Loan EMI Calculator",

    infoList: [
      {
        heading: "Budget-Friendly: ",
        info: "Helps you plan your monthly expenses.",
      },
      {
        heading: "Transparency: ",
        info: "Offers clarity on the repayment structure.",
      },
      {
        heading: "Lender Comparison: ",
        info: "Allows easy evaluation of loan offers.",
      },
      {
        heading: "Avoid Surprises: ",
        info: "Know your exact repayment amount in advance.",
      },
    ],

    headingTwo: "Why Choose Minemi’s Gold Loan EMI Calculator?",

    infoListTwo: [
      {
        heading: "Ease of Use:  ",
        info: "Accessible and simple for everyone.",
      },
      {
        heading: "Accurate Outputs: ",
        info: "Reliable EMI results for planning.",
      },
      {
        heading: "Comprehensive Insights: ",
        info: "Detailed breakdown of principal and interest amounts.",
      },
      {
        heading: "Compare and Apply: ",
        info: "Match EMI results with lender offers and apply directly.",
      },
    ],

    paraOne: "Take Control of Your Home Loan with MinEMI",
    paraTwo:
      "With MinEMI’s Home Loan Balance Transfer EMI Calculator, you can simplify your loan repayments, reduce EMIs, and save significantly. Start calculating today and make an informed financial decision!",
  },
];
